module.exports = __webpack_public_path__ + "img/2.805fccc8.jpg";